<template>
  <ul class="c-step-indicator">
    <li
      v-for="(isDone, index) in isDoneArray"
      class="c-step-indicator__step"
      :class="{ isCurrent: currentStep === index, isDone }"
      :style="style"
    >
      <span class="c-step-indicator__step-text" v-show="currentStep === index">
        {{ stepTexts[index] }}
      </span>
      <span
        class="c-step-indicator__line"
        v-if="index < isDoneArray.length - 1"
        :class="{ isFilled: isFilled(index) }"
      ></span>
      <span
        class="c-step-indicator__dot"
        :class="{ isCurrent: currentStep === index, isDone }"
        @click="$emit('step-clicked', index)"
      ></span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ComponentStepIndicator',
  props: {
    currentStep: {
      type: [Number, null],
      default: 0,
    },
    isDoneArray: {
      type: Array,
      default: () => [],
    },
    stepTexts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    style() {
      return {
        width:
          this.isDoneArray.length > 0
            ? `${80 / this.isDoneArray.length}vw`
            : '80vw',
      }
    },
  },
  methods: {
    isFilled(index) {
      return (
        this.isDoneArray[index] &&
        (this.isDoneArray[index + 1] || this.currentStep === index + 1)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-step-indicator {
  background-color: #9ad1ed;
  bottom: 0;
  display: flex;
  height: 55px;
  justify-content: center;
  left: 0;
  margin: auto;
  padding-top: 15px;
  position: fixed;
  right: 0;
  width: 100%;

  &__step {
    position: relative;
  }

  &__step-text {
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    position: absolute;
    text-align: center;
    top: -5px;
    width: 100%;
  }

  &__dot {
    background-color: variables.$color-text-gray;
    border-radius: 5px;
    bottom: 0;
    content: '';
    cursor: pointer;
    display: block;
    height: 9px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.2s;
    width: 9px;

    &.isCurrent {
      transform: scale(1.5);
      background-color: #fff;
    }

    &.isDone {
      background-color: #fff;
    }
  }

  &__line {
    background-color: variables.$color-text-gray;
    bottom: 0;
    content: '';
    display: block;
    left: 50%;
    height: 1px;
    margin: auto;
    position: absolute;
    top: 0;
    width: 100%;

    &.isFilled {
      background-color: #fff;
    }
  }
}
</style>
